import { User } from '@/Stores/UserStore';
import Vue from 'vue';
import { mapGetters } from 'vuex';

const UserMixin = Vue.extend({
    beforeMount() {
        this.loadUser();
    },
    computed: {
        ...mapGetters('userModule', {
            user: 'user',
            authenticated: 'authenticated',
            allowedLocations: 'allowedLocations',
            currentRoles: 'currentRoles'
        }),
        isInternal(): boolean {
            return this.authenticated && !!this.user && !!this.user.id;
        }
    },
    methods: {
        async loadUser() {
            await this.$typedStore.modules.userModule.actions.getUser();
            await this.$typedStore.modules.userModule.actions.getAuthenticationStatus();
            await this.$typedStore.modules.userModule.actions.getAllowedLocations();
            await this.$typedStore.modules.userModule.actions.getCurrentRoles();
        }
    }
});

export default UserMixin;
